// import logo from '../assets/images/logos/Logo Outlined.png';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {

  return (
    <div className="flex h-screen">
      <aside className="bg-gray-800 w-5/5">
        <div className="p-4 flex items-center justify-center">
          {/* <img src={logo} alt="Logo" className="h-12 w-12" /> */}
        </div>
        <ul className="mt-4">
          <li className="px-4 py-2 text-white hover:bg-gray-700 cursor-pointer">Dashboard</li>
          <li className="px-4 py-2 text-white hover:bg-gray-700 cursor-pointer">
          <Link to="/users">Users</Link>
          </li>
          <li className="px-4 py-2 text-white hover:bg-gray-700 cursor-pointer">
            <Link to="/cargo">Cargo</Link>
          </li>
        </ul>
      </aside>

    </div>
  );
};

export default AdminDashboard;
